import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import SaveIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class FormSubCategory extends Component {
  static propTypes = {
    classes: PropTypes.object,
    fullScreen: PropTypes.bool,

    close: PropTypes.func,
    open: PropTypes.bool,

    subCategory: PropTypes.object,

    createSubCategory: PropTypes.func,
    updateSubCategory: PropTypes.func,
    deleteSubCategory: PropTypes.func,
    refresh: PropTypes.func,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      loading: false,
      color: undefined,
      title: "",
      cover: "",
      description: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.props.open) {
      this.init(nextProps.subCategory);
    }
  }

  init(subCategory) {
    this.setState({
      loading: false,
      title: subCategory ? subCategory.title : "",
      description: subCategory ? subCategory.description : "",
      color: subCategory ? subCategory.color : "",
      cover: subCategory ? subCategory.cover : "",
    });
  }

  handleTextChange = (name) => (event) => {
    const value = event.target.value;

    this.setState({
      [name]: value,
    });
  };

  delete() {
    const { NotificationCenter } = this.context;
    NotificationCenter.sweetAlert(
      {
        title: `Are you sure ?`,
        subtitle:
          "If you delete this subCategory , you won't be able to recover it.",
        timestamp: new Date().getTime(),
        error: true,
      },
      {
        cancel: {
          label: "Cancel",
          level: "default",
          callback: () => console.log("Callback"),
        },
        confirm: {
          label: "I am sure",
          level: "error",
          callback: this.confirmDelete.bind(this),
        },
      }
    );
  }

  async confirmDelete() {
    const { deleteSubCategory, close, refresh, subCategory } = this.props;

    const { NotificationCenter } = this.context;
    close();
    const resp = await deleteSubCategory(subCategory.id);
    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: "SubCategory  has been deleted.",
        success: true,
        timestamp: new Date().getTime(),
      });
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  async save() {
    const {
      updateSubCategory,
      createSubCategory,
      subCategory,
      refresh,
      close,
    } = this.props;

    const { title, description, cover, color } = this.state;

    const { NotificationCenter } = this.context;

    let resp = undefined;
    this.setState({ loading: true });

    if (subCategory) {
      resp = await updateSubCategory(subCategory.id, {
        title,
        cover,
        description,
        color: color && color.hex ? color.hex : color,
      });
    } else {
      resp = await createSubCategory({
        title,
        cover,
        description,
        color: color && color.hex ? color.hex : undefined,
      });
    }

    this.setState({ loading: false });

    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: subCategory
          ? "SubCategory  has been updated."
          : "SubCategory  has been created.",
        success: true,
        timestamp: new Date().getTime(),
      });

      close();
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  render() {
    const { classes, fullScreen, open, subCategory, close } = this.props;

    const { title, description, loading, cover, color } = this.state;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        scroll="paper"
        onClose={() => {
          this.setState({
            title: "",
            description: "",
          });
          close();
        }}
        aria-labelledby="responsive-dialog-title"
      >
        {loading ? (
          <div className={classes.progressContainer}>
            <DialogTitle id="alert-dialog-title">Loading</DialogTitle>
            <CircularProgress />
          </div>
        ) : (
          <div>
            <DialogTitle id="responsive-dialog-title">
              {subCategory
                ? `${subCategory.title}`
                : "Let's Create a New SubCategory "}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {subCategory
                  ? "To update the subCategory , fill the form below :"
                  : "To create a new subCategory , fill the form below :"}
              </DialogContentText>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    id="title"
                    variant="filled"
                    label="Title *"
                    className={classes.textField}
                    value={title}
                    onChange={this.handleTextChange("title")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="outlined-textarea"
                    label="Description"
                    placeholder="Description"
                    multiline
                    className={classes.textField}
                    margin="normal"
                    variant="outlined"
                    value={description}
                    onChange={this.handleTextChange("description")}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              {subCategory ? (
                <Button
                  className={classes.delete}
                  onClick={this.delete.bind(this)}
                >
                  <DeleteIcon className={classes.leftIcon} /> Delete
                </Button>
              ) : (
                []
              )}
              <Button onClick={close}>
                <CloseIcon className={classes.leftIcon} /> Close
              </Button>
              <Button color="primary" autoFocus onClick={this.save.bind(this)}>
                <SaveIcon className={classes.leftIcon} />{" "}
                {subCategory ? "Save" : "Create"}
              </Button>
            </DialogActions>
          </div>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(withMobileDialog()(FormSubCategory));
